import { TieredMenu } from "primereact/tieredmenu";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Sidebar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const sideBarItems = useMemo(
    () => [
      {
        label: "Преподаватели",
        icon: "pi pi-list",
        command: () => {
          navigate("/teachers");
        },
        className: pathname === "/teachers" ? "p-focus" : "",
      },
      {
        label: "Добавяне на преподавател",
        icon: "pi pi-user-plus",
        command: () => {
          navigate("/teachers/create");
        },
        className: pathname === "/teachers/create" ? "p-focus" : "",
      },
      {
        label: "Справки",
        icon: "pi pi-receipt",
        items: [
          {
            label: "Справка преподаватели",
            icon: "pi pi-file",
            command: () => {
              navigate("/teachers/report");
            },
            className: pathname === "/teachers/report" ? "p-focus" : "",
          },
        ],
      },
    ],
    [pathname, navigate],
  );

  return <TieredMenu model={sideBarItems} breakpoint="767px" className="w-full" />;
};

export default Sidebar;
